import { TAuthor } from '../post/post.types'

export enum EInterviewRank {
  ENTRY = 'ENTRY',
  JUNIOR = 'JUNIOR',
  MIDDLE = 'MIDDLE',
  SENIOR = 'SENIOR',
  EXPERT = 'EXPERT',
}

export type TQuestionCategory = {
  title?: string
  question: string
  slug: string
}

export type TQuestion = {
  id: string
  question: string
  slug: string
  answer: string
  company: string
  description: string
  createdBy: {
    firstName: string
    lastName: string
    username: string
    imageUrl: string
  }
  rank: {
    name: EInterviewRank
    slug: string
  }
  readStatus: {
    isMarkRead: boolean
  }
  isMarkRead: boolean
  categories: TQuestionCategory[]
  topic: {
    slug: string
  }
  previousQuestion: {
    id: string
    question: string
    slug: string
  }
  nextQuestion: {
    id: string
    question: string
    slug: string
  }
  encryptedData: string
}

export type TQuestionSuggestResponse = {
  data: TQuestion[]
}

export type TQuestionsStore = Record<string, TQuestion>

export type TGetQuestionsResponse = {
  total: number
  items: TQuestion[]
  encryptedData: string
}

export type TQuestionsParams = {
  categorySlug?: string
  rankSlug?: string
  keyword?: string
}

export type TCountQuestionsParams = {
  categorySlug?: string
}

export type TCountQuestionResponse = {
  count: number
}

export type TQuestionComment = {
  id: string
  content: string
  parentId?: string
  createdAt: string
  user: TAuthor
}

export type TCreateQuestionComment = {
  content: string
  questionSlug: string
  parentId?: string | null
}

export type TQuestionCommentResponse = {
  data: TQuestionComment[]
}

export type TQuestionCommentsResponse = {
  data: TQuestionComment[]
}
